/* lp-reason-slides-el: the swipe carousel of one article row. A scroll-snap track (the browser does the swiping) with a dot pager: the active dot
   follows the scroll position, a dot tap scrolls to its picture. No autoplay, no framework. */
(function () {
  if (customElements.get('lp-reason-slides-el')) return;
  customElements.define('lp-reason-slides-el', class extends HTMLElement {
    connectedCallback() {
      var track = this.querySelector('[data-lp-track]');
      var dots = Array.prototype.slice.call(this.querySelectorAll('[data-lp-dot]'));
      if (!track || !dots.length) return;
      var ticking = false;
      function paint() {
        ticking = false;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      track.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }, { passive: true });
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          track.scrollTo({ left: Number(d.getAttribute('data-lp-dot')) * track.clientWidth, behavior: 'smooth' });
        });
      });
    }
  });
})();
